// extracted by mini-css-extract-plugin
module.exports = {"grid":"CategoriesList_grid__iRrtb"};